// Public API for the unified tracking module. Call sites should import only
// from here — internal modules (providers, registry, catalog) are an
// implementation detail.

export {
	trackAnalyticsEvent,
	trackPageView,
	loadAnalyticsProviders,
} from './registry';

export {
	ANALYTICS_EVENT_PAGE_VIEW,
	ANALYTICS_EVENT_VIEW_ITEM,
	ANALYTICS_EVENT_VIEW_ITEM_LIST,
	ANALYTICS_EVENT_ADD_TO_CART,
	ANALYTICS_EVENT_REMOVE_FROM_CART,
	ANALYTICS_EVENT_VIEW_CART,
	ANALYTICS_EVENT_BEGIN_CHECKOUT,
	ANALYTICS_EVENT_ADD_SHIPPING_INFO,
	ANALYTICS_EVENT_ADD_PAYMENT_INFO,
	ANALYTICS_EVENT_PURCHASE,
	ANALYTICS_EVENT_BUYLIST_SUBMIT,
} from './analytics-events';

export type {
	AnalyticsEventName,
	AnalyticsEventPayload,
	AnalyticsProviderId,
} from './analytics-events';

export type { LoadAnalyticsProvidersConfig } from './registry';
